module.exports = __webpack_public_path__ + "img/saad-profile-logo-small.2c10543e.jpg";